module.exports = __webpack_public_path__ + "static/media/nus_master_cert.6911d6b7.pdf";